export enum DateFormat {
  none_yyyyMMdd,
  none_yyMMdd,
  hyphen_yyyyMMdd,
  dot_yyyyMMdd,
}

export const DateFormatLabels: { [key: number]: string } = {
  [DateFormat.none_yyyyMMdd]: "yyyyMMdd",
  [DateFormat.none_yyMMdd]: "yyMMdd",
  [DateFormat.hyphen_yyyyMMdd]: "yyyy-MM-dd",
  [DateFormat.dot_yyyyMMdd]: "yyyy.MM.dd",
}
